import React from 'react';
import Sidebar from './Sidebar';

interface MainLayoutProps {
  children: React.ReactNode;
  role: string;
  username: string;
  onLogout: () => void;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children, role, username, onLogout }) => {
  return (
    <div className="flex min-h-screen bg-white">
      <Sidebar role={role} username={username} onLogout={onLogout} />

      <main className="flex-1 min-w-0 relative px-8 lg:px-16 py-8 overflow-y-auto">
        <div className="w-full">
          {children}
        </div>
      </main>
    </div>
  );
};

export default MainLayout;